export const mockData = {
  categories: ['mirim', 'infantil', 'juvenil', 'adulto', 'master'],
  phases: ['grupos', 'quartas', 'semifinal', 'final'],
  players: {
    grupos: {
       mirim: [
        { id: 17, name: 'Bruno Oliveira', birthDate: '2012-03-15', wins: 2, goals: 8, goalsConceded: 6 },
        { id: 18, name: 'Miguel Santos', birthDate: '2013-07-22', wins: 3, goals: 11, goalsConceded: 4 },
        { id: 19, name: 'Arthur Costa', birthDate: '2012-11-08', wins: 1, goals: 5, goalsConceded: 8 },
        { id: 20, name: 'Samuel Lima', birthDate: '2013-01-30', wins: 2, goals: 9, goalsConceded: 7 }
      ],
      infantil: [
        { id: 1, name: 'João Silva', birthDate: '2010-03-15', wins: 3, goals: 12, goalsConceded: 8 },
        { id: 2, name: 'Pedro Santos', birthDate: '2011-07-22', wins: 2, goals: 10, goalsConceded: 9 },
        { id: 3, name: 'Lucas Oliveira', birthDate: '2010-11-08', wins: 2, goals: 8, goalsConceded: 7 },
        { id: 4, name: 'Gabriel Costa', birthDate: '2011-01-30', wins: 1, goals: 6, goalsConceded: 11 }
      ],
      juvenil: [
        { id: 5, name: 'Rafael Lima', birthDate: '2007-05-12', wins: 4, goals: 15, goalsConceded: 6 },
        { id: 6, name: 'Mateus Ferreira', birthDate: '2008-09-03', wins: 3, goals: 13, goalsConceded: 8 },
        { id: 7, name: 'Diego Alves', birthDate: '2007-12-18', wins: 1, goals: 7, goalsConceded: 12 },
        { id: 8, name: 'Thiago Rocha', birthDate: '2008-04-25', wins: 0, goals: 4, goalsConceded: 15 }
      ],
      adulto: [
        { id: 9, name: 'Carlos Eduardo', birthDate: '1995-08-14', wins: 5, goals: 18, goalsConceded: 9 },
        { id: 10, name: 'Anderson Silva', birthDate: '1992-11-30', wins: 4, goals: 16, goalsConceded: 11 },
        { id: 11, name: 'Roberto Carlos', birthDate: '1988-02-17', wins: 2, goals: 11, goalsConceded: 13 },
        { id: 12, name: 'Marcelo Santos', birthDate: '1990-06-21', wins: 1, goals: 9, goalsConceded: 16 }
      ],
      master: [
        { id: 13, name: 'José Almeida', birthDate: '1975-03-10', wins: 3, goals: 14, goalsConceded: 10 },
        { id: 14, name: 'Paulo Henrique', birthDate: '1978-07-05', wins: 3, goals: 12, goalsConceded: 9 },
        { id: 15, name: 'Antônio Pereira', birthDate: '1972-12-22', wins: 2, goals: 10, goalsConceded: 11 },
        { id: 16, name: 'Francisco Lima', birthDate: '1976-09-15', wins: 0, goals: 6, goalsConceded: 15 }
      ]
    },
    quartas: {
      infantil: {
        confronto1: {
          player1: { id: 1, name: 'João Silva', goals: 3 },
          player2: { id: 2, name: 'Pedro Santos', goals: 1 },
          status: 'finalizado',
          winner: 1
        },
        confronto2: {
          player1: { id: 3, name: 'Lucas Oliveira', goals: 2 },
          player2: { id: 4, name: 'Gabriel Costa', goals: 4 },
          status: 'finalizado',
          winner: 4
        }
      },
      juvenil: {
        confronto1: {
          player1: { id: 5, name: 'Rafael Lima', goals: 5 },
          player2: { id: 6, name: 'Mateus Ferreira', goals: 2 },
          status: 'finalizado',
          winner: 5
        },
        confronto2: {
          player1: { id: 7, name: 'Diego Alves', goals: 1 },
          player2: { id: 8, name: 'Thiago Rocha', goals: 3 },
          status: 'finalizado',
          winner: 8
        }
      },
      adulto: {
        confronto1: {
          player1: { id: 9, name: 'Carlos Eduardo', goals: null },
          player2: { id: 10, name: 'Anderson Silva', goals: null },
          status: 'em_andamento'
        },
        confronto2: {
          player1: { id: 11, name: 'Roberto Carlos', goals: null },
          player2: { id: 12, name: 'Marcelo Santos', goals: null },
          status: 'aguardando'
        }
      },
      master: {
        confronto1: {
          player1: { id: 13, name: 'José Almeida', goals: 4 },
          player2: { id: 14, name: 'Paulo Henrique', goals: 2 },
          status: 'finalizado',
          winner: 13
        },
        confronto2: {
          player1: { id: 15, name: 'Antônio Pereira', goals: 3 },
          player2: { id: 16, name: 'Francisco Lima', goals: 1 },
          status: 'finalizado',
          winner: 15
        }
      }
    },
    semifinal: {
      geral: {
        confronto1: {
          player1: { id: 1, name: 'João Silva', category: 'infantil', goals: 2 },
          player2: { id: 5, name: 'Rafael Lima', category: 'juvenil', goals: 4 },
          status: 'finalizado',
          winner: 5
        },
        confronto2: {
          player1: { id: 13, name: 'José Almeida', category: 'master', goals: null },
          player2: { id: 15, name: 'Antônio Pereira', category: 'master', goals: null },
          status: 'aguardando'
        }
      }
    },
    final: {
      geral: {
        confronto_final: {
          player1: { id: 5, name: 'Rafael Lima', category: 'juvenil', goals: null },
          player2: { id: null, name: 'Aguardando Semifinal', category: 'TBD', goals: null },
          status: 'aguardando'
        }
      }
    }
  },
  currentMatches: [
    {
      id: 1,
      category: 'adulto',
      player1: { id: 9, name: 'Carlos Eduardo', goals: 2 },
      player2: { id: 10, name: 'Anderson Silva', goals: 1 },
      status: 'ongoing'
    },
    {
      id: 2,
      category: 'juvenil',
      player1: { id: 5, name: 'Rafael Lima', goals: 1 },
      player2: { id: 6, name: 'Mateus Ferreira', goals: 1 },
      status: 'ongoing'
    }
  ]
};